import { render, staticRenderFns } from "./ResetPasswordStep3.vue?vue&type=template&id=36cb3d1c"
import script from "./ResetPasswordStep3.vue?vue&type=script&lang=js"
export * from "./ResetPasswordStep3.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordStep3.vue?vue&type=style&index=0&id=36cb3d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports